export default {
    loadEventQuestions: function (eventId, questions, deleted, fetchTime) {
        return {type: 'EVENT_QUESTIONS_LOADED', eventId, questions, deleted, fetchTime};
    },
    markAsDeleted: function (eventId, IDs) {
        return {type: 'EVENT_QUESTIONS_MARKED_DELETED', deleted: IDs};
    },
    setFilter: function (eventId, filterText) {
        return {type: 'EVENT_QUESTIONS_SET_FILTER', eventId, text: filterText};
    },
    add: function (eventId, question) {
        return {type: 'EVENT_QUESTIONS_ADD', eventId, question};
    },
    update: function (eventId, questionId, question, lastUpdate) {
        return {type: 'EVENT_QUESTIONS_UPDATE', eventId, questionId, question, lastUpdate};
    },
    delete: function (eventId, questionId) {
        return {type: 'EVENT_QUESTIONS_DELETE', eventId, questionId};
    },
    setAnswers: function (eventId, questionId, answers, mineCount, fetchTime) {
        return {type: 'EVENT_QUESTION_SET_ANSWERS', eventId, questionId, answers, mineCount, fetchTime};
    },
    addAnswer: function (eventId, questionId, answer) {
        return {type: 'EVENT_QUESTION_ADD_ANSWER', eventId, questionId, answer};
    },
    updateAnswer: function (eventId, questionId, answerId, answer) {
        return {type: 'EVENT_QUESTION_UPDATE_ANSWER', eventId, questionId, answerId, answer};
    },
    deleteAnswer: function (eventId, questionId, answerId) {
        return {type: 'EVENT_QUESTION_DELETE_ANSWER', eventId, questionId, answerId};
    },
    markAsRead: function (eventId) {
        return {type: 'EVENT_QUESTIONS_MARK_AS_READ', eventId};
    },
};
